import { Button } from "@itandi/itandi-bb-ui/Button";
import { ModalBody } from "@itandi/itandi-bb-ui/ModalBody";
import { ModalFooter } from "@itandi/itandi-bb-ui/ModalFooter";
import { ModalHeader } from "@itandi/itandi-bb-ui/ModalHeader";
import { Modalv2 } from "@itandi/itandi-bb-ui/Modalv2";
import React from "react";
import { toast } from "react-toastify";
import { ScheduleInputForm } from "~/components/common/construction_schedule/ScheduleInputForm";
import type { NskResponse } from "~/models/Api";
import type { Deal } from "~/models/Deal";
import type { DealConstructionScheduleEdit } from "~/models/DealConstructionSchedule";
import {
	buildInitialSchedules,
	isInvalidSchedule
} from "~/models/DealConstructionSchedule";
import { isSuccess } from "~/utils/api/api_handler";

type Props = {
	deal: Deal;
	handleClose: () => void;
	handleMutate: () => Promise<void>;
	handleSubmit: (
		schedules: DealConstructionScheduleEdit[]
	) => Promise<NskResponse>;
	isOpen: boolean;
};

export const ScheduleInputModal: React.FC<Props> = ({
	deal,
	isOpen,
	handleClose,
	handleSubmit,
	handleMutate
}: Props) => {
	const [schedules, setSchedules] = React.useState<
		DealConstructionScheduleEdit[]
	>(buildInitialSchedules(deal));
	const [submitting, setSubmitting] = React.useState<boolean>(false);
	const [touchSubmit, setTouchSubmit] = React.useState<boolean>(false);
	const onSubmitSchedule = async (): Promise<void> => {
		setTouchSubmit(true);
		if (schedules.some((s) => isInvalidSchedule(s))) {
			// invalid
			return;
		}
		setSubmitting(true);
		const filteredSchedules = schedules.filter((s) => s.startDate !== null);
		const result = await handleSubmit(filteredSchedules);
		if (isSuccess(result)) {
			await handleMutate();
			handleClose();
			toast.success("登録しました");
			setSubmitting(false);
			return;
		}
		setSubmitting(false);
		toast.error(`エラーが発生しました。${result.message}`);
	};
	const handleChange = (newSchedules: DealConstructionScheduleEdit[]): void => {
		setSchedules(newSchedules);
	};
	return (
		<Modalv2 isOpen={isOpen} onClose={handleClose}>
			<ModalHeader title="工事日程登録" />
			<ModalBody>
				<ScheduleInputForm
					handleChange={handleChange}
					schedules={schedules}
					touchSubmit={touchSubmit}
				/>
			</ModalBody>
			<ModalFooter
				leftArea={
					<Button onClick={handleClose} variant="secondary" width="fill">
						キャンセル
					</Button>
				}
				rightArea={
					<Button
						disabled={submitting}
						onClick={onSubmitSchedule}
						variant="primary"
						width="fill"
					>
						確定
					</Button>
				}
			/>
		</Modalv2>
	);
};
